<form
    class="container"
    [class.horizontal]="orientation == 'horizontal'"
    [class.vertical]="orientation == 'vertical'"
    [style.gap]="gap"
>   
    @for (item of _items(); track $index) {
        <app-radio-button
            [disabled]="disabled"
            [value]="item.value"
            [label]="item.label"
            [name]="name"
            (select)="onSelect($event)"
        >
        </app-radio-button>
    }

</form>